import { customElement } from 'lit/decorators.js';
import { LtnSettingsService } from '../ltn-settings/ltn-settings-service.js';
import type { Settings, SettingsObject } from '../ltn-settings/ltn-settings-service.js';

export type { Settings, SettingsObject };

@customElement('ns-settings-service')
export class NSSettingsService extends LtnSettingsService {
  protected _name = 'ns-settings';

  constructor() {
    super();

    this.setAppSettings({
      companyId: '',
    });
  }

  protected _appConstants: SettingsObject = {
    app: {
      name: '%{APP_TITLE}%',
      title: '%{APP_TITLE}%',
      code: '%{APP_CODE}%',
      version: '%{BUILD_VERSION}%',
      buildDate: '%{BUILD_DATE}%',
      mode: '%{BUILD_MODE}%',
      url: '%{APP_URL}%',
    },
    buttress: {
      endpoint: '%{BUTTRESS_URL}%',
      apiPath: '%{BUTTRESS_API_PATH}%',
    },
    google: {
      apiKeys: {
        maps: '%{GOOGLE_MAPS_API_KEY}%',
      },
    },
    stripe: {
      publishableTestKey: '%{STRIPE_PUBLISHABLE_TEST_KEY}%',
      publishableLiveKey: '%{STRIPE_PUBLISHABLE_LIVE_KEY}%',
    },
  };
}
